"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.starts-with");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _shopList = require("@/api/shop/shopList");
var _BookingTimeConfig = _interopRequireDefault(require("./BookingTimeConfig"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 图片状态常量
 */
var IMAGE_STATE = {
  UNCHANGED: 'unchanged',
  // 保持原值
  NEW: 'new',
  // 新上传
  DELETED: 'deleted' // 已删除
};
var _default = exports.default = {
  name: 'BatchSetting',
  components: {
    BookingTimeConfig: _BookingTimeConfig.default
  },
  data: function data() {
    return {
      IMAGE_STATE: IMAGE_STATE,
      // 暴露给模板
      cards: [{
        key: 'ts',
        label: '堂食公告'
      }, {
        key: 'zt',
        label: '自提公告'
      }, {
        key: 'wm',
        label: '外卖公告'
      }, {
        key: 'dt',
        label: '大团公告'
      }],
      // 公告图片状态管理
      noticeImageStates: {
        ts: IMAGE_STATE.UNCHANGED,
        zt: IMAGE_STATE.UNCHANGED,
        wm: IMAGE_STATE.UNCHANGED,
        dt: IMAGE_STATE.UNCHANGED
      },
      welfareImageState: IMAGE_STATE.UNCHANGED,
      qrBgImageState: IMAGE_STATE.UNCHANGED,
      // 配置选项
      configOptions: {
        business: false,
        businessTime: false,
        orderMode: false,
        invoice: false,
        delivery: false,
        openBill: false,
        notice: false,
        booking: false,
        busyTime: false,
        welfare: false,
        bookingTime: false
      },
      innerNotices: this.ensure(),
      // 营业设置标签
      businessTab: 'dine',
      // 营业设置数据
      businessSetting: {
        weekDays: [],
        startTime: null,
        endTime: null
      },
      // 营业时间配置数据
      businessTimeConfig: {
        selectedWeeks: [],
        ts: {
          startTime: null,
          endTime: null
        },
        zt: {
          startTime: null,
          endTime: null
        },
        ws: {
          startTime: null,
          endTime: null
        }
      },
      // 点餐模式配置数据
      orderModeConfig: {
        orderMode: null
      },
      // 预订设置数据
      bookingConfig: {
        canBook: null,
        preTime: null
      },
      // 繁忙时段数据
      busyTimeConfig: {
        bsyTimeGroup: [{
          start: null,
          end: null
        }],
        bsyPlusTime: null
      },
      // 推送设置数据
      pushSetting: {
        selfPickup: false,
        selfPickupTime: '',
        delivery: false,
        deliveryTime: ''
      },
      // 开票配置数据
      billConfig: {
        dineInvoice: '',
        rechargeInvoice: '',
        voucherInvoice: '',
        invoiceType: null
      },
      formData: {},
      invoiceCompanyOptions: [],
      // 福利社配置数据
      welfareConfig: {
        imageUrl: []
      },
      // 二维码背景图配置数据
      qrBgConfig: {
        imageUrl: []
      },
      // 外卖配置数据
      deliveryConfig: {
        postage: '',
        minOrder: '',
        freeShipping: '',
        shippingActivity: false,
        // activityStartTime: '',
        // activityEndTime: '',
        timeRange: [],
        activityPostage: '',
        weeklyActivity: false,
        // weeklyDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        // weeklyPostage: '3',
        // 周期运费活动
        periodFeeActivity: false,
        periodFee: {
          enable: 0,
          weeks: [],
          dateRange: [],
          dayStartTime: null,
          dayEndTime: null,
          fee: ''
        }
      },
      // 门店搜索文本
      storeSearchText: '',
      // 门店树形数据
      storeTreeData: [],
      // 树形控件属性
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 默认展开的节点
      expandedKeys: [1, 2],
      // 默认选中的节点
      checkedKeys: [],
      checkedLeafKeys: [],
      isSyncingFromParent: false,
      imageFile: null,
      resPath: process.env.VUE_APP_COMMENT_IMAGE_URL,
      // 预约时间配置数据
      bookingTimeData: null
    };
  },
  watch: {
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTree.filter(val);
    },
    innerNotices: {
      deep: true,
      handler: function handler(v) {
        if (this.isSyncingFromParent) return;
        this.$set(this.formData, 'notices', _objectSpread({}, v));
      }
    }
  },
  computed: {
    // 周期运费星期全选状态
    isPeriodFeeWeekAllSelected: {
      get: function get() {
        var weeks = this.deliveryConfig.periodFee.weeks;
        return weeks.length === 7;
      },
      set: function set(value) {
        // Vue的v-model会调用setter
      }
    },
    // 周期运费星期半选状态
    isPeriodFeeWeekIndeterminate: function isPeriodFeeWeekIndeterminate() {
      var weeks = this.deliveryConfig.periodFee.weeks;
      return weeks.length > 0 && weeks.length < 7;
    }
  },
  created: function created() {
    var _this = this;
    this.getStoreTreeData();
    (0, _shopList.getInvoiceCompanyList)().then(function (res) {
      _this.invoiceCompanyOptions = res.data;
    });
  },
  methods: {
    ensure: function ensure() {
      var defaults = {
        ts: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        },
        zt: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        },
        wm: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        },
        dt: {
          iconUrl: [],
          dateRange: [],
          weeks: [],
          timeRange: {
            start: '',
            end: ''
          },
          title: '',
          content: ''
        }
      };
      var current = this.formData && this.formData.notices ? this.formData.notices : {};

      // 处理iconUrl：后端返回的是字符串（已含 /images/mall 前缀），需要转换为数组格式供el-upload使用
      var imagePath = this.resPath || 'https://img3.gagacafe.com';
      var processItem = function processItem(item, name) {
        if (!item) return _objectSpread({}, defaults[name]);
        // 创建新对象，避免直接修改原数据
        var result = _objectSpread({}, item);
        // 处理 iconUrl
        if (!result.iconUrl) {
          result.iconUrl = [];
        } else if (typeof result.iconUrl === 'string') {
          if (result.iconUrl) {
            result.iconUrl = [{
              name: name,
              url: imagePath + result.iconUrl
            }];
          } else {
            result.iconUrl = [];
          }
        } else if (!Array.isArray(result.iconUrl)) {
          result.iconUrl = [];
        }

        // 处理日期格式：兼容新旧两种格式
        if (!result.dateRange) {
          // 新格式：date: {start, end} → dateRange: [start, end]
          if (result.date && (0, _typeof2.default)(result.date) === 'object') {
            var _result$date = result.date,
              start = _result$date.start,
              end = _result$date.end;
            result.dateRange = start && end ? [start, end] : [];
          } else {
            result.dateRange = [];
          }
        }
        if (!result.weeks) result.weeks = [];
        if (!result.timeRange) {
          // 如果有旧的 time 字段，迁移到 timeRange
          result.timeRange = result.time || {
            start: '',
            end: ''
          };
        }
        return result;
      };
      return {
        ts: _objectSpread(_objectSpread({}, defaults.ts), processItem(current.ts, 'ts')),
        zt: _objectSpread(_objectSpread({}, defaults.zt), processItem(current.zt, 'zt')),
        wm: _objectSpread(_objectSpread({}, defaults.wm), processItem(current.wm, 'wm')),
        dt: _objectSpread(_objectSpread({}, defaults.dt), processItem(current.dt, 'dt'))
      };
    },
    getStoreTreeData: function getStoreTreeData() {
      var _this2 = this;
      (0, _shopList.queryStore)({}).then(function (res) {
        _this2.storeTreeData = res.data;
      });
    },
    /**
     * 公告图片删除
     */
    handleRemove: function handleRemove(key) {
      this.innerNotices[key].iconUrl = [];
      this.$set(this.noticeImageStates, key, IMAGE_STATE.DELETED);
      this.$set(this.formData, key, '');
    },
    /**
     * 公告图片上传
     */
    handleChange: function handleChange(file, fileList, key) {
      if (fileList.length > 0) {
        var fileObj = file.raw;
        // 设置预览
        this.innerNotices[key].iconUrl = [{
          name: file.name,
          url: URL.createObjectURL(fileObj)
        }];
        // 标记为新上传
        this.$set(this.noticeImageStates, key, IMAGE_STATE.NEW);
        // 存储文件
        this.$set(this.formData, key, fileObj);
      } else {
        // 删除
        this.innerNotices[key].iconUrl = [];
        this.$set(this.noticeImageStates, key, IMAGE_STATE.DELETED);
        this.$set(this.formData, key, '');
      }
      return false;
    },
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传一张图片，新图片将替换原有图片');
    },
    /**
     * 福利社图片删除
     */
    handleWelfareRemove: function handleWelfareRemove() {
      this.welfareConfig.imageUrl = [];
      this.welfareImageState = IMAGE_STATE.DELETED;
      this.$set(this.formData, 'welfareImg', '');
    },
    handleWelfareExceed: function handleWelfareExceed() {
      this.$message.warning('只能上传一张图片，新图片将替换原有图片');
    },
    /**
     * 福利社图片上传前校验
     */
    handleWelfareUpload: function handleWelfareUpload(file) {
      var isImage = file.type && file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      return false;
    },
    /**
     * 福利社图片变化
     */
    handleWelfareChange: function handleWelfareChange(file, fileList) {
      if (fileList.length > 0) {
        var fileObj = file.raw;
        // 设置预览
        this.welfareConfig.imageUrl = [{
          name: file.name,
          url: URL.createObjectURL(fileObj)
        }];
        // 标记为新上传
        this.welfareImageState = IMAGE_STATE.NEW;
        // 存储文件
        this.$set(this.formData, 'welfareImg', fileObj);
      } else {
        // 删除
        this.welfareConfig.imageUrl = [];
        this.welfareImageState = IMAGE_STATE.DELETED;
        this.$set(this.formData, 'welfareImg', '');
      }
      return false;
    },
    /**
     * 二维码背景图删除
     */
    handleQrBgRemove: function handleQrBgRemove() {
      this.qrBgConfig.imageUrl = [];
      this.qrBgImageState = IMAGE_STATE.DELETED;
      this.$set(this.formData, 'qrBgImg', '');
    },
    handleQrBgExceed: function handleQrBgExceed() {
      this.$message.warning('只能上传一张图片，新图片将替换原有图片');
    },
    /**
     * 二维码背景图上传前校验
     */
    handleQrBgUpload: function handleQrBgUpload(file) {
      var isImage = file.type && file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      return false;
    },
    /**
     * 二维码背景图变化
     */
    handleQrBgChange: function handleQrBgChange(file, fileList) {
      if (fileList.length > 0) {
        var fileObj = file.raw;
        // 设置预览
        this.qrBgConfig.imageUrl = [{
          name: file.name,
          url: URL.createObjectURL(fileObj)
        }];
        // 标记为新上传
        this.qrBgImageState = IMAGE_STATE.NEW;
        // 存储文件
        this.$set(this.formData, 'qrBgImg', fileObj);
      } else {
        // 删除
        this.qrBgConfig.imageUrl = [];
        this.qrBgImageState = IMAGE_STATE.DELETED;
        this.$set(this.formData, 'qrBgImg', '');
      }
      return false;
    },
    /**
     * 公告图片上传前校验
     */
    handleUpload: function handleUpload(file) {
      var isImage = file.type && file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      return false;
    },
    /**
     * 添加繁忙时间段
     */
    addBusyTime: function addBusyTime() {
      this.busyTimeConfig.bsyTimeGroup.push({
        start: null,
        end: null
      });
    },
    /**
     * 删除繁忙时间段
     */
    removeBusyTime: function removeBusyTime(index) {
      this.busyTimeConfig.bsyTimeGroup.splice(index, 1);
    },
    /**
     * 周期运费星期全选/取消全选
     */
    handlePeriodFeeWeekSelectAll: function handlePeriodFeeWeekSelectAll(checked) {
      this.$set(this.deliveryConfig.periodFee, 'weeks', checked ? [1, 2, 3, 4, 5, 6, 7] : []);
    },
    /**
     * 公告星期全选/取消全选
     */
    handleNoticeWeekSelectAll: function handleNoticeWeekSelectAll(key) {
      var weeks = this.innerNotices[key] && this.innerNotices[key].weeks || [];
      var isAllSelected = weeks.length === 7;
      this.$set(this.innerNotices[key], 'weeks', isAllSelected ? [] : [1, 2, 3, 4, 5, 6, 7]);
    },
    // 判断公告星期是否全选
    isNoticeWeekAllSelected: function isNoticeWeekAllSelected(key) {
      var weeks = this.innerNotices[key] && this.innerNotices[key].weeks || [];
      return weeks.length === 7;
    },
    // 判断公告星期是否半选
    isNoticeWeekIndeterminate: function isNoticeWeekIndeterminate(key) {
      var weeks = this.innerNotices[key] && this.innerNotices[key].weeks || [];
      return weeks.length > 0 && weeks.length < 7;
    },
    /**
     * 处理门店选择变化
     */
    // handleStoreCheck(data, checked, indeterminate) {
    //   console.log('门店选择变化:', data, checked, indeterminate)
    //
    //
    // },
    handleStoreCheck: function handleStoreCheck(data, checked) {
      var _this3 = this;
      console.log('门店选择变化:', data, checked);
      if (checked) {
        // 拦截非叶子节点选择
        if (data.children && data.children.length > 0) {
          //获取checked.children的所有id
          data.children.map(function (item) {
            if (!_this3.checkedLeafKeys.includes(item.id)) {
              _this3.checkedLeafKeys = _this3.checkedLeafKeys.concat(item.id);
            }
          });
          // this.$refs.storeTree.setCheckedKeys(checkedKeys)
        }
        console.log('最终选中的叶子节点:', data.children);
        if (data.children == null) {
          // 直接检查数组是否包含该元素
          if (!this.checkedLeafKeys.includes(data.id)) {
            this.checkedLeafKeys = this.checkedLeafKeys.concat(data.id);
          }
        }
      } else {
        this.checkedLeafKeys = this.checkedLeafKeys.filter(function (id) {
          return id !== data.id;
        });
      }
      // 更新选中的叶子节点集合
      // this.checkedLeafKeys = this.$refs.storeTree.getCheckedKeys(true);
    },
    saveSelectedLeaves: function saveSelectedLeaves() {
      // 提交时只保存叶子节点
      console.log('最终选中的叶子节点:', this.checkedLeafKeys);
      // 这里可以添加保存逻辑...
    },
    /**
     * 选择全部门店
     */
    selectAllStores: function selectAllStores() {
      // 获取所有叶子节点的key
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = [];
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            keys = keys.concat(_getAllLeafKeys(node.children));
          } else {
            keys.push(node.id);
          }
        });
        return keys;
      };
      var allKeys = _getAllLeafKeys(this.storeTreeData);
      this.$refs.storeTree.setCheckedKeys(allKeys);
    },
    /**
     * 全选星期
     */
    selectAllWeeks: function selectAllWeeks() {
      if (this.businessTimeConfig.selectedWeeks.length === 7) {
        this.businessTimeConfig.selectedWeeks = [];
      } else {
        this.businessTimeConfig.selectedWeeks = [1, 2, 3, 4, 5, 6, 7];
      }
    },
    /**
     * 过滤节点
     */
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /**
     * 提取相对路径
     * 将完整URL转换为相对路径
     */
    extractRelativePath: function extractRelativePath(fullUrl) {
      if (!fullUrl) return '';

      // 如果已经是相对路径，直接返回
      if (!fullUrl.startsWith('http')) {
        return fullUrl;
      }

      // 尝试移除 resPath 前缀
      if (this.resPath && fullUrl.startsWith(this.resPath)) {
        return fullUrl.replace(this.resPath, '');
      }

      // 尝试移除完整URL前缀
      var prefixes = ['https://img3.gagacafe.com', 'http://img3.gagacafe.com', 'https://opstest.gagacafe.com', 'http://opstest.gagacafe.com', 'https://api.gagacafe.com', 'http://api.gagacafe.com'];
      for (var _i = 0, _prefixes = prefixes; _i < _prefixes.length; _i++) {
        var prefix = _prefixes[_i];
        if (fullUrl.startsWith(prefix)) {
          return fullUrl.replace(prefix, '');
        }
      }

      // 无法处理，返回原值
      return fullUrl;
    },
    /**
     * 创建空文件（用于表示删除图片）
     */
    createEmptyFile: function createEmptyFile() {
      var emptyBlob = new Blob([''], {
        type: 'image/png'
      });
      return new File([emptyBlob], 'empty.png', {
        type: 'image/png'
      });
    },
    /**
     * 处理预约时间配置提交
     */
    handleBookingTimeSubmit: function handleBookingTimeSubmit(data) {
      this.bookingTimeData = data.bookingTimeConfig;
    },
    /**
     * 取消操作
     */
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    /**
     * 提交设置
     */
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      if (!this.checkedLeafKeys || this.checkedLeafKeys.length === 0) {
        this.$message.error('请选择门店');
        return;
      }

      // 显示全局loading
      var loading = this.$loading({
        lock: true,
        text: '正在批量设置中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 构建营业时间配置JSON数组
      var servTimeConfig = [];
      if (this.configOptions.businessTime && this.businessTimeConfig.selectedWeeks.length > 0) {
        this.businessTimeConfig.selectedWeeks.forEach(function (week) {
          servTimeConfig.push({
            ts: {
              start_time: _this4.businessTimeConfig.ts.startTime,
              end_time: _this4.businessTimeConfig.ts.endTime
            },
            zt: {
              start_time: _this4.businessTimeConfig.zt.startTime,
              end_time: _this4.businessTimeConfig.zt.endTime
            },
            ws: {
              start_time: _this4.businessTimeConfig.ws.startTime,
              end_time: _this4.businessTimeConfig.ws.endTime
            },
            week: String(week)
          });
        });
      }

      // 构建周期运费活动JSON
      var periodFee = null;
      if (this.deliveryConfig.periodFeeActivity && this.deliveryConfig.periodFee.weeks.length > 0) {
        var pf = this.deliveryConfig.periodFee;
        periodFee = {
          enable: pf.enable,
          act_week: pf.weeks.join(','),
          fee: pf.fee,
          day_start_time: pf.dayStartTime,
          day_end_time: pf.dayEndTime
        };
        // 添加有效日期
        if (pf.dateRange && pf.dateRange.length === 2) {
          periodFee.start = pf.dateRange[0];
          periodFee.end = pf.dateRange[1];
        }
      }
      var formDataReq = new FormData();
      this.formData = _objectSpread(_objectSpread({}, this.formData), {}, {
        "selectedStores": this.checkedLeafKeys
      });

      // 只有选中对应配置选项时才添加
      if (this.configOptions.invoice) {
        this.formData.pushSetting = this.pushSetting;
      }
      if (this.configOptions.openBill) {
        this.formData.billConfig = this.billConfig;
      }
      if (this.configOptions.delivery) {
        this.formData.deliveryConfig = this.deliveryConfig;
      }

      // 如果有营业时间配置，添加到formData
      if (this.configOptions.businessTime) {
        if (servTimeConfig.length > 0) {
          this.formData.servTimeConfig = servTimeConfig;
        }
      }

      // 如果有点餐模式配置，添加到formData
      if (this.configOptions.orderMode) {
        this.formData.billConfig = _objectSpread(_objectSpread({}, this.formData.billConfig || {}), {}, {
          orderMode: this.orderModeConfig.orderMode
        });
      }

      // 如果有预订配置，添加到formData
      if (this.configOptions.booking) {
        this.formData.bookingConfig = this.bookingConfig;
      }

      // 如果有繁忙时段配置，添加到formData
      if (this.configOptions.busyTime) {
        this.formData.busyTimeConfig = this.busyTimeConfig;
      }

      // 如果有周期运费活动配置，添加到formData
      if (periodFee) {
        this.formData.periodFee = periodFee;
      }

      // 如果有预约时间配置，添加到formData
      if (this.configOptions.bookingTime && this.$refs.bookingTimeConfig) {
        var config = this.$refs.bookingTimeConfig.config;
        this.formData.bookingTimeConfig = JSON.stringify(config);
      }

      // 如果有公告配置，添加到formData
      if (this.configOptions.business && this.innerNotices) {
        var keys = ['ts', 'zt', 'wm', 'dt'];
        this.formData.notices = {};
        keys.forEach(function (k) {
          if (_this4.innerNotices[k]) {
            // 根据图片状态决定 iconUrl 的值
            var iconUrlStr = null; // null 表示不修改，使用后端原有值
            var state = _this4.noticeImageStates[k];
            if (state === IMAGE_STATE.DELETED) {
              // 已删除 - 使用空字符串表示删除
              iconUrlStr = '';
            } else if (state === IMAGE_STATE.NEW) {
              // 新上传 - 后端会处理新文件，这里传空字符串
              iconUrlStr = '';
            }
            // UNCHANGED 状态保持 iconUrlStr = null，后端会保持原有值

            // 兼容新旧格式：优先使用 date 对象，否则从 dateRange 转换
            var dateObj = {
              start: '',
              end: ''
            };
            if (_this4.innerNotices[k].date && (0, _typeof2.default)(_this4.innerNotices[k].date) === 'object') {
              // 新格式：已经是 date 对象
              dateObj = {
                start: _this4.innerNotices[k].date.start || '',
                end: _this4.innerNotices[k].date.end || ''
              };
            } else if (_this4.innerNotices[k].dateRange && Array.isArray(_this4.innerNotices[k].dateRange) && _this4.innerNotices[k].dateRange.length === 2) {
              // 旧格式：从 dateRange 数组转换
              dateObj = {
                start: _this4.innerNotices[k].dateRange[0] || '',
                end: _this4.innerNotices[k].dateRange[1] || ''
              };
            }
            _this4.formData.notices[k] = {
              content: _this4.innerNotices[k].content || '',
              iconUrl: iconUrlStr,
              date: dateObj,
              timeRange: _this4.innerNotices[k].timeRange || {
                start: '',
                end: ''
              },
              title: _this4.innerNotices[k].title || '',
              weeks: _this4.innerNotices[k].weeks || []
            };
          }
        });
      }

      // 根据图片状态添加文件到 FormData
      // 公告图片
      var noticeKeys = ['ts', 'zt', 'wm', 'dt'];
      noticeKeys.forEach(function (k) {
        var state = _this4.noticeImageStates[k];
        if (state === IMAGE_STATE.NEW) {
          // 新上传 - 添加文件
          formDataReq.append(k, _this4.formData[k] || null);
        } else if (state === IMAGE_STATE.DELETED) {
          // 已删除 - 发送空文件表示删除
          var emptyFile = _this4.createEmptyFile();
          formDataReq.append(k, emptyFile);
        }
        // UNCHANGED 不添加该字段，后端会保留原有值
      });

      // 福利社图片
      if (this.welfareImageState === IMAGE_STATE.NEW) {
        formDataReq.append('welfareImg', this.formData.welfareImg || null);
      } else if (this.welfareImageState === IMAGE_STATE.DELETED) {
        var emptyFile = this.createEmptyFile();
        formDataReq.append('welfareImg', emptyFile);
      }

      // 二维码背景图
      if (this.qrBgImageState === IMAGE_STATE.NEW) {
        formDataReq.append('qrBgImg', this.formData.qrBgImg || null);
      } else if (this.qrBgImageState === IMAGE_STATE.DELETED) {
        var _emptyFile = this.createEmptyFile();
        formDataReq.append('qrBgImg', _emptyFile);
      }

      // 清理 formData 中的文件字段
      noticeKeys.forEach(function (k) {
        return delete _this4.formData[k];
      });
      delete this.formData.welfareImg;
      delete this.formData.qrBgImg;
      formDataReq.append('formData', JSON.stringify(this.formData));
      (0, _shopList.batchUpdateStore)(formDataReq).then(function (res) {
        _this4.$message.success('批量设置成功');
        _this4.$emit('submit', _this4.formData);
      }).catch(function (error) {
        console.error('批量设置失败:', error);
      }).finally(function () {
        // 关闭loading
        loading.close();
      });
    }
  }
};